<template>
  <div class="compressed-content">
    <h3>Have you had Type 2 diabetes for more than 10 years?</h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.hadDiabetesType2">
      <b-form-radio v-model="survey.bloodSugar.diabetesHistory.hadDiabetesType2" name="hadDiabetesType2"
                    :value="true">Yes</b-form-radio>
      <b-form-radio v-model="survey.bloodSugar.diabetesHistory.hadDiabetesType2" name="hadDiabetesType2"
                    :value="false">No</b-form-radio>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import { required } from "vuelidate/lib/validators";

  export default {
    mixins: [formMixin],

    validations: {
      hadDiabetesType2: {
        required
      }
    },

    computed: {
      ...mapState(["survey"]),

      hadDiabetesType2() { return this.survey.bloodSugar.diabetesHistory.hadDiabetesType2; }
    }
  };
</script>